import cn from 'clsx';
import { observer } from 'mobx-react';
import styles from './index.module.scss';

export enum SIZE_MAP {
  SIZE_48 = 'size48',
  SIZE_40 = 'size40',
  SIZE_32 = 'size32',
  SIZE_24 = 'size24',
  SIZE_20 = 'size20',
  SIZE_16 = 'size16',
  SIZE_14 = 'size14',
}

export enum CIRCLE_COLOR_MAP {
  WHITE = 'white',
  BLACK = 'black',
  RED = 'red',
}

interface LoadingIconProps {
  style?: React.CSSProperties;
  className?: string;
  type?: CIRCLE_COLOR_MAP; // laoding颜色
  size?: SIZE_MAP; // 圆的大小
}

const getLoadingPadding = (size: SIZE_MAP) => {
  switch (size) {
    case SIZE_MAP.SIZE_48:
      return '6px';
    case SIZE_MAP.SIZE_40:
      return '5px';
    case SIZE_MAP.SIZE_32:
      return '4px';
    case SIZE_MAP.SIZE_24:
      return '3px';
    case SIZE_MAP.SIZE_20:
      return '2.5px';
    case SIZE_MAP.SIZE_16:
      return '2px';
    case SIZE_MAP.SIZE_14:
      return '1.75px';
  }
};

const getCircleWidth = (size: SIZE_MAP) => {
  switch (size) {
    case SIZE_MAP.SIZE_48:
      return 36;
    case SIZE_MAP.SIZE_40:
      return 30;
    case SIZE_MAP.SIZE_32:
      return 24;
    case SIZE_MAP.SIZE_24:
      return 18;
    case SIZE_MAP.SIZE_20:
      return 15;
    case SIZE_MAP.SIZE_16:
      return 12;
    case SIZE_MAP.SIZE_14:
      return 10.5;
  }
};

const getStrokeColor = (type: CIRCLE_COLOR_MAP) => {
  switch (type) {
    case CIRCLE_COLOR_MAP.BLACK:
      return '#1A1A1A';
    case CIRCLE_COLOR_MAP.RED:
      return '#CC0C1C';
    default:
      return '#FFFFFF';
  }
};

const UKLoadingIcon: React.FC<LoadingIconProps> = observer(
  ({ className, style, type = CIRCLE_COLOR_MAP.WHITE, size = SIZE_MAP.SIZE_40 }) => {
    const circleWidth = getCircleWidth(size);
    const loadingPadding = getLoadingPadding(size);
    const strokeColor = getStrokeColor(type);

    return (
      <div
        className={cn(styles.loadingIcon, className)}
        style={{
          ...style,
          padding: loadingPadding,
        }}
      >
        <svg
          className={styles.loadingSvg}
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 24 24'
          style={{
            width: circleWidth,
            height: circleWidth,
            stroke: strokeColor,
          }}
        >
          <circle
            className={styles.loadingCircle}
            fill='none'
            stroke-width='2'
            stroke-linecap='round'
            cx='12'
            cy='12'
            r='9.5'
          />
        </svg>
      </div>
    );
  },
);

export default UKLoadingIcon;
